<div id="app-snackbar" *ngIf="message" [ngClass]="message.cssClass">
  {{ message.text }}
</div>
